import { useState, forwardRef } from 'react';
import { Eye, EyeOff } from 'lucide-react';

/**
 * Password input with built-in show/hide toggle (eye icon).
 * Drop-in replacement for <input type="password" /> — all standard input props
 * are forwarded. Additional prop `iconColor` tunes the eye icon tint (default white/60).
 */
const PasswordInput = forwardRef(function PasswordInput(
  { className = '', iconColor = 'text-white/60 hover:text-white/90', wrapperClassName = '', ...props },
  ref
) {
  const [visible, setVisible] = useState(false);
  return (
    <div className={`relative ${wrapperClassName}`}>
      <input
        ref={ref}
        autoCorrect="off"
        autoCapitalize="none"
        spellCheck={false}
        {...props}
        type={visible ? 'text' : 'password'}
        className={`${className} pr-12`}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        className={`absolute right-2 top-1/2 -translate-y-1/2 p-2 ${iconColor} transition-colors z-10`}
        style={{ WebkitTapHighlightColor: 'transparent' }}
        aria-label={visible ? 'Nascondi password' : 'Mostra password'}
        tabIndex={-1}
        data-testid={props['data-testid'] ? `${props['data-testid']}-toggle` : 'password-visibility-toggle'}
      >
        {visible ? <EyeOff size={20} /> : <Eye size={20} />}
      </button>
    </div>
  );
});

export default PasswordInput;
